import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from '@angular/common';

@Pipe({
	standalone: true,
	name: 'prix'
})
export class PrixPipe implements PipeTransform {

	constructor(
		private currencyPipe: CurrencyPipe
	) {
	}

	/**
	 * Transforme une valeur en prix sous forme de chaine.
	 * @param valeur la valeur
	 * @param afficherSymbole (optionnel) true pour afficher le symbol
	 * @param nbDecimales (optionnel) le nombre de décimales du prix, 2 par défaut
	 */
	transform(valeur: any, afficherSymbole?: boolean, nbDecimales: number = 2): string {
		let display = '';
		if (afficherSymbole) {
			display = 'symbol';
		}
		return this.currencyPipe.transform(valeur, 'EUR', display, `1.${nbDecimales}-${nbDecimales}`);
	}
}
